import Image from "next/image";
import classNames from "classnames";

// components
import Link from "@/components/Link";

// interfaces
import { ICollectionBox } from "../ICollectionsMain";

// assets
import ArrowRightIcon from "@/components/icons/ArrowRightIcon";

import styles from "@/assets/styles/containers/collections-main.module.scss";


const CollectionBox = ({ slug, pictureUrl, title, caption, isDouble }: ICollectionBox) => {
  return (
    <div
      className={classNames(styles["locl-collections-main__content__explore__box"], {
        [styles["locl-collections-main__content__explore__box-double"]]: isDouble
      })}
      data-testid="locl-collections-main-content-explore-box"
    >
      <Link href={`/collections/post/${slug}`} data-testid="locl-collections-main-content-explore-box-link">
        <div className={styles["locl-collections-main__content__explore__box__content"]}>
          {pictureUrl && (
            <Image
              width={isDouble ? 667 : 320}
              height={340}
              src={pictureUrl}
              alt={title}
              className={styles["locl-collections-main__content__explore__box__image"]}
              loading="lazy"
            />
          )}
          <div className={styles["locl-collections-main__content__explore__box__info"]}>
            <h3 className={styles["locl-collections-main__content__explore__box__title"]}>
              {title}
            </h3>
          </div>
          {caption && (
            <div className={styles["locl-collections-main__content__explore__box__caption"]}>
              <h6 className={styles["locl-collections-main__content__explore__box__caption__text"]}>
                {caption}
              </h6>
            </div>
          )}
          <div className={styles["locl-collections-main__content__explore__box__button"]}>
            Explore <ArrowRightIcon />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CollectionBox;
